import commonPostTypeConfig from '../../common/postTypes/banner'

export default function initPostType({ wapp }) {
    return wapp.client.postTypes.getPostType({
        name: 'banner',
        addIfThereIsNot: true,
        statusManager: commonPostTypeConfig.getStatusManager()
    })
}
